import { render, staticRenderFns } from "./1-before-login.vue?vue&type=template&id=6a23725d&scoped=true&"
import script from "./1-before-login.vue?vue&type=script&lang=ts&"
export * from "./1-before-login.vue?vue&type=script&lang=ts&"
import style0 from "./1-before-login.vue?vue&type=style&index=0&id=6a23725d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23725d",
  null
  
)

export default component.exports